import React, { Fragment, useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import { Button, Col, Row, Table } from "reactstrap";
import html2canvas from "html2canvas";
import { GetCookieToken } from "../../Cookie/GetCookie";
import axios from "axios";
import { toThaiDate } from "../../../helpers/date_helper";

// import * as THSarabunNew from "../../../assets/fonts/THSarabunNew.ttf";

const API_URL = process.env.REACT_APP_API_CORS;

function Bookcertificate(props) {
  const { dateFrom, dateTo, budYear, userID } = props;
  const token = GetCookieToken("userToken");
  const [dataHeader, setDataHeader] = useState([]);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [totalLeaveID1, setTotalLeaveID1] = useState(0);
  const [totalLeaveID2, setTotalLeaveID2] = useState(0);
  const [totalLeaveIDLate, setTotalLeaveIDLate] = useState(0);
  const [totalLeaveID4, setTotalLeaveID4] = useState(0);
  const [totalLeaveID3, setTotalLeaveID3] = useState(0);
  const [totalLeaveID9, setTotalLeaveID9] = useState(0);
  const [totalLeaveID6, setTotalLeaveID6] = useState(0);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [dayData, setDayData] = useState([]);
  const [thaiDateTimes, setThaiDateTimes] = useState({
    date: null,
    leave_type_id: null,
    leave_day: null,
    text_date: null,
  });
  const [lateTimes, setLateTimes] = useState({
    date: null,
    leave_type_id: null,
    leave_day: null,
    text_date: null,
  });
  const pdfRef = useRef();

  const downloadPDF = async () => {
    setButtonLoading(true);
    const input = pdfRef.current;
    await html2canvas(input, { scale: 3 }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4", true); //แนวนอน
      // const pdf = new jsPDF("", "mm", "a4", true);   //แนวตั้ง
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;

      const imgY = 20;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("หนังสือรับรองวันลา.pdf");
    });
    setButtonLoading(false);
  };

  const handleFetchbyMonth = async (dateFrom, dateTo, budYear, userID) => {
    const dateObjectFrom = new Date(dateFrom);
    const yearFrom = dateObjectFrom.getFullYear();
    const monthFrom = (dateObjectFrom.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const dayFrom = dateObjectFrom.getDate().toString().padStart(2, "0");
    const formattedDateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

    const dateObjectTo = new Date(dateTo);
    const yearTo = dateObjectTo.getFullYear();
    const monthTo = (dateObjectTo.getMonth() + 1).toString().padStart(2, "0");
    const dayTo = dateObjectTo.getDate().toString().padStart(2, "0");
    const formattedDateTo = `${yearTo}-${monthTo}-${dayTo}`;

    const url = `${API_URL}/api/report/leave/byMonth?mode=json`;
    try {
      const data = {
        user_id: userID,
        dmy_start: formattedDateFrom,
        dmy_end: formattedDateTo,
        budget_year: budYear,
      };

      const response = await axios.post(url, data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(response.data.dayData);
      
      setThaiDateTimes({
        date: response.data.dataTable.map(i => i.write_date),
        leave_type_id: response.data.dataTable.map(i => i.leave_type_id),
        leave_day: response.data.dataTable.map(i => i.leave_days),
        text_date: response.data.dataTable.map(i => i.text_date),
      });
      setDayData(response.data.dayData);
      setDataHeader(response.data.dataHeader);

      const DStart = toThaiDate(String(response.data.dataHeader.dmy_start));
      const DEnd = toThaiDate(String(response.data.dataHeader.dmy_end));
      setDateStart(DStart);
      setDateEnd(DEnd);

      const totals = response.data.dataTable.reduce((acc, i) => {
        const leaveType = i.leave_type_id;
        const days = parseFloat(i.leave_days);
            
        if (!isNaN(days)) {
          acc[leaveType] = (acc[leaveType] || 0) + days;
        }
      
        return acc;
      }, {});
      setTotalLeaveID1(totals[1] || 0);
      setTotalLeaveID2(totals[2] || 0);
      setTotalLeaveID3(totals[3] || 0);
      setTotalLeaveID4(totals[4] || 0);
      setTotalLeaveID6(totals[6] || 0);
      setTotalLeaveID9(totals[9] || 0);

      // const sum1 = response.data.dataTable
      //   .map(i => {
      //     if (i.leave_type_id === 1) {
      //       return parseInt(i.leave_days);
      //     }
      //     return 0;
      //   })
      //   .reduce((acc, currentValue) => acc + currentValue, 0);
      // setTotalLeaveID1(sum1);

      // const sum2 = response.data.dataTable
      //   .map(i => {
      //     if (i.leave_type_id === 2) {
      //       return parseInt(i.leave_days);
      //     }
      //     return 0;
      //   })
      //   .reduce((acc, currentValue) => acc + currentValue, 0);
      // setTotalLeaveID2(sum2);

      // const sum4 = response.data.dataTable
      //   .map(i => {
      //     if (i.leave_type_id === 4) {
      //       const val = parseFloat(i.leave_days);
      //       return isNaN(val) ? 0 : val;
      //     }
      //     return 0;
      //   })
      //   .reduce((acc, currentValue) => acc + currentValue, 0);
      // setTotalLeaveID4(sum4);

      // const sum3 = response.data.dataTable
      //   .map(i => {
      //     if (i.leave_type_id === 3) {
      //       return parseInt(i.leave_days);
      //     }
      //     return 0;
      //   })
      //   .reduce((acc, currentValue) => acc + currentValue, 0);
      // setTotalLeaveID3(sum3);

      // const sum9 = response.data.dataTable
      //   .map(i => {
      //     if (i.leave_type_id === 9) {
      //       return parseInt(i.leave_days);
      //     }
      //     return 0;
      //   })
      //   .reduce((acc, currentValue) => acc + currentValue, 0);
      // setTotalLeaveID9(sum9);

      // const sum6 = response.data.dataTable
      //   .map(i => {
      //     if (i.leave_type_id === 6) {
      //       return parseInt(i.leave_days);
      //     }
      //     return 0;
      //   })
      //   .reduce((acc, currentValue) => acc + currentValue, 0);
      // setTotalLeaveID6(sum6);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFetchHistory = async (dateFrom, dateTo, userID) => {
    const dateObjectFrom = new Date(dateFrom);
    const yearFrom = dateObjectFrom.getFullYear();
    const monthFrom = (dateObjectFrom.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const dayFrom = dateObjectFrom.getDate().toString().padStart(2, "0");
    const formattedDateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

    const dateObjectTo = new Date(dateTo);
    const yearTo = dateObjectTo.getFullYear();
    const monthTo = (dateObjectTo.getMonth() + 1).toString().padStart(2, "0");
    const dayTo = dateObjectTo.getDate().toString().padStart(2, "0");
    const formattedDateTo = `${yearTo}-${monthTo}-${dayTo}`;

    const url = `${API_URL}/api/time/history`;
    try {
      const response = await axios.get(url, {
        params: {
          page: 1,
          size: 10,
          order: ["user_id", "DESC"],
          filter: {
            late: [1],
            date_start: formattedDateFrom,
            date_end: formattedDateTo,
            user_id: [Number(userID)],
          },
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      });

      setLateTimes({
        date: response.data.result.map(i => i.date),
        leave_type_id: "สาย",
        leave_day: 1,
      });

      setTotalLeaveIDLate(response.data.result.length);
    } catch (error) {
      console.error(error);
    }
  };

  let combinedData;

  useEffect(() => {
    if (
      dateFrom !== null &&
      dateTo !== null &&
      budYear !== null &&
      userID !== null
    ) {
      handleFetchbyMonth(dateFrom, dateTo, budYear, userID);
      handleFetchHistory(dateFrom, dateTo, userID);
    }
  }, [dateFrom, dateTo, budYear, userID]);

  const formattedLateData = lateTimes.date?.map((date, index) => ({
    date,
    leave_day: 1,
    leave_type_id: "สาย",
    text_date: null,
  }));
  const formattedData = thaiDateTimes.date?.map((date, index) => ({
    date,
    leave_day: thaiDateTimes.leave_day[index],
    leave_type_id: thaiDateTimes.leave_type_id[index],
    text_date: thaiDateTimes.text_date[index],
  }));
  if (formattedLateData !== undefined && formattedData !== undefined) {
    combinedData = [...formattedData, ...formattedLateData];
  }

  return (
    <div>
      <div
        ref={pdfRef}
        style={{
          fontFamily: "Sarabun,serif",
          minWidth:"1106px"
        }}
      >
        <Row>
          <Col lg={12} className="text-center">
            <h4 style={{ fontWeight: "600" }}>หนังสือรับรองวันลา</h4>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="text-center">
            <h4 style={{ fontWeight: "600" }}>
              ประจำปีงบประมาณ พ.ศ. {dataHeader.budget_year}
            </h4>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="text-center">
            <h4> <span className="pe-1" style={{ fontWeight: "600" }}>ขอรับรองว่า</span> {dataHeader.user_name} <span className="px-1" style={{ fontWeight: "600" }}>ตำแหน่ง</span> {dataHeader.user_position_name} </h4>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="text-center">
            <h4>{dataHeader.cont_to_name_1}</h4>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="text-center">
            {dateStart !== null && dateEnd !== null ? ( <h4> <span className="pe-1" style={{ fontWeight: "600" }}>มีวันลาตั้งแต่</span> {dateStart.split(" 0:00:00")[0]} <span className="pe-1" style={{ fontWeight: "600" }}>ถึงวันที่</span> {dateEnd.split(" 0:00:00")[0]} <span className="pe-1" style={{ fontWeight: "600" }}>ดังต่อไปนี้</span></h4> ) : ( "" )}
          </Col>
        </Row>
        <br />
        <Row>
          <Col
            lg={12}
            className="text-center"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <table className="border border-1 border-black ">
              <thead className="border border-1 border-black table-light">
                <tr>
                  <th className="text-center border border-1 border-black" style={{ width: "160px" }}> วัน เดือน ปี</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> ลาป่วย</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> ลากิจ</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> สาย</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> ลาพักผ่อน</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> ลาคลอด</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> ลาศึกษาต่อ</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> ลาอุปสมบท</th>
                  <th className="text-center border border-1 border-black" style={{ width: "70px" }}> หมายเหตุ</th>
                </tr>
              </thead>
              <tbody>
                {combinedData !== null
                  ? combinedData?.map((elm, idx) => {
                      const indexOfT = elm.date.indexOf("T");
                      const cutDateTime = elm.date.substring(0, indexOfT);
                      const thaiDate = toThaiDate(cutDateTime);
                      const dateTHNoTimes = thaiDate.split(" 0:00:00")[0];
                      return (
                        <tr key={idx}>
                          <td className="text-start ps-1 border border-1 border-black" style={{whiteSpace:"nowrap"}}>
                            {elm.text_date !== null
                              ? elm.text_date
                              : dateTHNoTimes}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === 1 ? elm.leave_day : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === 2 ? elm.leave_day : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === "สาย"
                              ? elm.leave_day
                              : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === 4 ? elm.leave_day : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === 3 ? elm.leave_day : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === 9 ? elm.leave_day : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === 6 ? elm.leave_day : " - "}
                          </td>
                          <td className="text-center border border-1 border-black">
                            {elm.leave_type_id === null ? elm.leave_day : " - "}
                          </td>
                        </tr>
                      );
                    })
                  : ""}
                <tr style={{ fontWeight: "600" }}>
                  <td className="text-center border border-1 border-black ps-4">
                    รวม
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveID1 === 0 ? " - " : totalLeaveID1}
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveID2 === 0 ? " - " : totalLeaveID2}
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveIDLate === 0 ? " - " : totalLeaveIDLate}
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveID4 === 0 ? " - " : totalLeaveID4}
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveID3 === 0 ? " - " : totalLeaveID3}
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveID9 === 0 ? " - " : totalLeaveID9}
                  </td>
                  <td className="text-center border border-1 border-black">
                    {totalLeaveID6 === 0 ? " - " : totalLeaveID6}
                  </td>
                  <td className="text-center border border-1 border-black">{" - "}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <br />
        {dayData !== null ? (
          <Fragment>
            <Row>
              <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
                <div
                  className="d-flex justify-content-between pe-2"
                  style={{ fontWeight: "600" }}
                >
                  <span>
                    วันลาพักผ่อนประจำปีงบประมาณ พ.ศ. {dayData?.budget_year}
                  </span>
                  <span>{dayData?.limit_day}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
                <div
                  className="d-flex justify-content-between pe-2"
                  style={{ fontWeight: "600" }}
                >
                  <span>วันลาพักผ่อนสะสมยกมา</span>
                  <span>{dayData?.prev_year}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
                <div
                  className="d-flex justify-content-between pe-2"
                  style={{ fontWeight: "600" }}
                >
                  <span>รวมวันลาพักผ่อน</span>
                  <span>{dayData?.limit_day && dayData?.prev_year ? dayData?.limit_day + dayData?.prev_year : ""}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
                <div
                  className="d-flex justify-content-between pe-2"
                  style={{ fontWeight: "600" }}
                >
                  <span>ลามาแล้ว</span>
                  <span>{dayData?.used_day}</span>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
                <div
                  className="d-flex justify-content-between pe-2"
                  style={{ fontWeight: "600" }}
                >
                  <span>วันลาพักผ่อนคงเหลือ</span>
                  <span>
                    {dayData?.limit_day && dayData?.prev_year && dayData?.used_day ? 
                      (dayData?.limit_day + dayData?.prev_year) - dayData?.used_day 
                      : ""}
                  </span>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
                <div className="text-end pe-2" style={{ fontWeight: "600" }}>
                  <span>
                    (ลงชื่อ)..............................................................................................
                  </span>
                </div>
              </Col>
            </Row>
          </Fragment>
        ) : (
          ""
        )}
      </div>
      <br />
      <Row style={{minWidth:"1106px"}}>
        <Col xs={{offset: 5, order: 4, size: 5}} lg={{offset: 5, order: 4, size: 5}}>
          <div className="text-end me-2">
            <Button
              className="mt-2 "
              color="success"
              onClick={downloadPDF}
              disabled={buttonLoading}
            >
              {buttonLoading === true ? (
                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              ) : (
                <i className="fa-solid fa-print pe-2"></i>
              )}
              พิมพ์
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Bookcertificate;
